import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { ConfigService } from '../service/config.service';
 
@Directive({
  selector: '[removeIfFeatureOn]'
})
export class RemoveIfFeatureOnDirective implements OnInit {
  @Input('removeIfFeatureOn') featureName: string;
 
  constructor(private el: ElementRef,
              private configService: ConfigService) {
  }
 
  ngOnInit() {
    if (this.configService.featureOn(this.featureName)) {
      this.el.nativeElement.parentNode.removeChild(this.el.nativeElement);
    }
  }
}